<div class="container">

  <app-header-dialog [iconName]="'mail_outline'">
    Confirmação
  </app-header-dialog>

  <div class="data-wrapper">

    <div class="data">
      <div style="color: darkblue">
        <b>Confirme o pagamento</b>
      </div>
    </div>

    <div *ngIf="data.gateway === 'cielo'">
      <div class="data">
        <div>{{data.payload.Customer.Name}}</div>
      </div>

      <div class="data" *ngIf="data.payload.Payment.Type === 'CreditCard'">
        <div style="margin-bottom: 5px;">
          {{type}}
        </div>
        <div *ngIf="data.payload.Payment.Installments === '1'">
          Pagamenteo à Vista
        </div>
        <div style="margin-bottom: 5px;" *ngIf="data.payload.Payment.Installments !== '1'">
          Parcelas: {{data.payload.Payment.Installments}}
        </div>
        <div>
          Valor Total: R$ {{data.payload.Payment.Amount}},00
        </div>
      </div>

      <div class="data" *ngIf="data.payload.Payment.Type === 'Pix'">
        <div>{{type}}</div>
        <div>Valor Total: R$ {{data.payload.Payment.Amount}},00</div>
      </div>

    </div>

    <div *ngIf="data.gateway === 'assas'">
      <div class="data">
        <div>{{data.client.name}}</div>
      </div>

      <div class="data" *ngIf="type =='Cartão de Crédito'">
        <div>{{type}}</div>
        <div *ngIf="installmentCount != ''">
          {{installmentCount}} X {{installmentValue}}
        </div>
        <div *ngIf="data.payload.installmentCount == ''">
          <div>{{value}}</div>
        </div>
      </div>

      <div class="data" *ngIf="type =='Boleto Bancário' || type =='PIX'">
        <div>{{type}}</div>
        <div>{{value}}</div>
      </div>

    </div>

  </div>

  <div flex fxLayoutAlign="center" justify-content='center'>
    <button mat-raised-button mat-dialog-close>
      <span style="color: red">
        CANCELAR
      </span>
    </button>
    <button style="margin-left: 20px;" mat-raised-button (click)="matDialogRef.close(['ok', data])">
      <span style="color: green">
        CONFIRMAR
      </span>
    </button>
  </div>

</div>